import SnakerFlowDesigner from './src/SnakerFlowDesigner.vue'
export default SnakerFlowDesigner
